export default "__VITE_PUBLIC_ASSET__46b7399c__"